/* eslint-disable class-methods-use-this, no-unused-vars, import/prefer-default-export */
import { AnalyticsProvider, UserTraits } from "../types";

declare global {
  interface Window {
    analytics?: {
      identify(userId: string, traits?: Record<string, any>): void;
      track(event: string, properties?: Record<string, any>): void;
      page(name?: string, properties?: Record<string, any>): void;
      group(groupId: string, traits?: Record<string, any>): void;
      reset(): void;
    };
  }
}

export class SegmentProvider implements AnalyticsProvider {
  name = "segment";

  identify(userId: string, traits?: UserTraits): void {
    window.analytics?.identify(userId, traits);
  }

  track(event: string, properties?: Record<string, any>): void {
    window.analytics?.track(event, properties);
  }

  page(name?: string, properties?: Record<string, any>): void {
    window.analytics?.page(name, properties);
  }

  reset(): void {
    window.analytics?.reset();
  }

  group(groupId: string, traits?: Record<string, any>): void {
    window.analytics?.group(groupId, traits);
  }
}
